import React, { useEffect, useState } from 'react'
import db from '../../firebase'
import ProjectItem from '../ProjectItem/ProjectItem'
import './Projects.css'

function Projects() {

    const [projects, setProjects] = useState([])

    useEffect(() => {
        db.collection('projects').orderBy('timestamp', 'desc').onSnapshot(snapshot => (
            setProjects(snapshot.docs.map(doc => ({
                id: doc.id,
                project: doc.data()
            })))
        ))
    }, [])

    return (
        <div className="projects">
            <h1>Projects</h1>
            <div className="projectItems">
                {projects.map(({ id, project }) => (
                    <ProjectItem key={id} title={project.title} link={project.link} note={Boolean(project.note)} src={project.src} lang={project.lang} description={project.description} />
                ))}
            </div>
        </div>
    )
}

export default Projects
